import type { NavigationMenuItem } from '#ui/types';
import type { ComputedRef } from 'vue';

import { ROUTE_NAMES } from '~/constants/routes';

export const useAccountMenuItems = (): ComputedRef<NavigationMenuItem[][]> => {
    const localePath = useLocalePath();
    const { tt } = useTypedI18n();
    const { trackAccountBids, trackAccountYourAuctions, trackAccountYourDirectSales, trackAccountYourOrdersInDirectSales, trackAccountProfile } =
        useTracking();

    return computed<NavigationMenuItem[][]>(() => [
        [
            {
                label: tt('account.bids.title'),
                icon: 'lucide:hourglass',
                to: localePath('account-bids'),
                onSelect: trackAccountBids,
            },
            {
                label: tt('account.myAuctions.title'),
                icon: 'lucide:gavel',
                to: localePath(ROUTE_NAMES.ACCOUNT_YOUR_AUCTIONS),
                onSelect: trackAccountYourAuctions,
            },
            {
                label: tt('account.negotiations.buyer.menuItem'),
                icon: 'lucide:handshake',
                to: localePath(ROUTE_NAMES.ACCOUNT_BUYER_NEGOTIATIONS),
            },
        ],
        [
            {
                label: tt('account.myDirectSales.title'),
                icon: 'lucide:shopping-bag',
                to: localePath(ROUTE_NAMES.ACCOUNT_YOUR_DIRECT_SALES),
                onSelect: trackAccountYourDirectSales,
            },
        ],
        [
            {
                label: tt('account.orders.title'),
                icon: 'lucide:handbag',
                to: localePath(ROUTE_NAMES.ACCOUNT_ORDERS),
                onSelect: trackAccountYourOrdersInDirectSales,
            },
        ],
        [
            {
                label: tt('account.favorites.title'),
                icon: 'lucide:bookmark-check',
                to: localePath(ROUTE_NAMES.ACCOUNT_FAVORITES),
            },
        ],
        [
            {
                label: tt('common.profile'),
                icon: 'lucide:user',
                to: localePath('account-profile'),
                onSelect: trackAccountProfile,
            },
        ],
    ]);
};
